require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "theme", () => $03c7aa72d4763188$export$bca14c5b3b88a9c9);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var $5fc600550714d659$exports = {};

$parcel$export($5fc600550714d659$exports, "spectrum--darkest", () => $5fc600550714d659$export$4ecdba604f5f1f44, (v) => $5fc600550714d659$export$4ecdba604f5f1f44 = v);
var $5fc600550714d659$export$4ecdba604f5f1f44;
$5fc600550714d659$export$4ecdba604f5f1f44 = `gP7gvq_spectrum--darkest`;


var $33116a1ac1f127f3$exports = {};

$parcel$export($33116a1ac1f127f3$exports, "spectrum", () => $33116a1ac1f127f3$export$3311ab3a441bc141, (v) => $33116a1ac1f127f3$export$3311ab3a441bc141 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--dark", () => $33116a1ac1f127f3$export$68dc111a79481afd, (v) => $33116a1ac1f127f3$export$68dc111a79481afd = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--darkest", () => $33116a1ac1f127f3$export$4ecdba604f5f1f44, (v) => $33116a1ac1f127f3$export$4ecdba604f5f1f44 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--large", () => $33116a1ac1f127f3$export$a88a8dbe29386d31, (v) => $33116a1ac1f127f3$export$a88a8dbe29386d31 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--light", () => $33116a1ac1f127f3$export$efb37c2f79da8163, (v) => $33116a1ac1f127f3$export$efb37c2f79da8163 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--lightest", () => $33116a1ac1f127f3$export$baaa804dc80cce18, (v) => $33116a1ac1f127f3$export$baaa804dc80cce18 = v);
$parcel$export($33116a1ac1f127f3$exports, "spectrum--medium", () => $33116a1ac1f127f3$export$4c0c83b3f4303ef8, (v) => $33116a1ac1f127f3$export$4c0c83b3f4303ef8 = v);
var $33116a1ac1f127f3$export$3311ab3a441bc141;
var $33116a1ac1f127f3$export$68dc111a79481afd;
var $33116a1ac1f127f3$export$4ecdba604f5f1f44;
var $33116a1ac1f127f3$export$a88a8dbe29386d31;
var $33116a1ac1f127f3$export$efb37c2f79da8163;
var $33116a1ac1f127f3$export$baaa804dc80cce18;
var $33116a1ac1f127f3$export$4c0c83b3f4303ef8;
$33116a1ac1f127f3$export$3311ab3a441bc141 = `zA6MfG_spectrum`;
$33116a1ac1f127f3$export$68dc111a79481afd = `zA6MfG_spectrum--dark`;
$33116a1ac1f127f3$export$4ecdba604f5f1f44 = `zA6MfG_spectrum--darkest`;
$33116a1ac1f127f3$export$a88a8dbe29386d31 = `zA6MfG_spectrum--large`;
$33116a1ac1f127f3$export$efb37c2f79da8163 = `zA6MfG_spectrum--light`;
$33116a1ac1f127f3$export$baaa804dc80cce18 = `zA6MfG_spectrum--lightest`;
$33116a1ac1f127f3$export$4c0c83b3f4303ef8 = `zA6MfG_spectrum--medium`;


var $ed6c61a7b1f80a21$exports = {};

$parcel$export($ed6c61a7b1f80a21$exports, "spectrum--large", () => $ed6c61a7b1f80a21$export$a88a8dbe29386d31, (v) => $ed6c61a7b1f80a21$export$a88a8dbe29386d31 = v);
var $ed6c61a7b1f80a21$export$a88a8dbe29386d31;
$ed6c61a7b1f80a21$export$a88a8dbe29386d31 = `HAZavG_spectrum--large`;


var $f98c14b7e54291a5$exports = {};

$parcel$export($f98c14b7e54291a5$exports, "spectrum--light", () => $f98c14b7e54291a5$export$efb37c2f79da8163, (v) => $f98c14b7e54291a5$export$efb37c2f79da8163 = v);
var $f98c14b7e54291a5$export$efb37c2f79da8163;
$f98c14b7e54291a5$export$efb37c2f79da8163 = `PFjRbG_spectrum--light`;


var $7ada9fcc793cf5cf$exports = {};

$parcel$export($7ada9fcc793cf5cf$exports, "spectrum--medium", () => $7ada9fcc793cf5cf$export$4c0c83b3f4303ef8, (v) => $7ada9fcc793cf5cf$export$4c0c83b3f4303ef8 = v);
var $7ada9fcc793cf5cf$export$4c0c83b3f4303ef8;
$7ada9fcc793cf5cf$export$4c0c83b3f4303ef8 = `xSyFOq_spectrum--medium`;


let $03c7aa72d4763188$export$bca14c5b3b88a9c9 = {
    global: (/*@__PURE__*/$parcel$interopDefault($33116a1ac1f127f3$exports)),
    light: (/*@__PURE__*/$parcel$interopDefault($f98c14b7e54291a5$exports)),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($5fc600550714d659$exports))),
    medium: (/*@__PURE__*/$parcel$interopDefault($7ada9fcc793cf5cf$exports)),
    large: (/*@__PURE__*/$parcel$interopDefault($ed6c61a7b1f80a21$exports))
};


//# sourceMappingURL=main.js.map
